// 导出 对应的不同接口的URL地址
const domain = {
    Base_M1_URL: 'https://prod.api.health-mirror.cn/', //模块一接口地址
    Base_M2_URL: 'https://ssp.hug-ability.com/', //模块二接口地址
    Base_M3_URL: 'https://test.api.health-mirror.cn/', //模块三接口地址
}
export default domain

